import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { CButton } from '@coreui/react-pro';

import { checkProductHasSeat, useOutsideHandling } from '../../../../../../utils';
import { LOCAL_CART, TAB_SELECT_PURCHASE } from '../../../../../../constants';
import images from '../../../../../../assets/images/index';
import TooltipWithIcon from '../../../../../General/Tooltips/TooltipWithIcon';

import { TrainingProductCardContext } from './TrainingProductCard';
import { fetchGuestContentManagements } from '../../../../../../containers/guest/action';
import SimpleCheckboxWithTooltip from '../../../../../General/Forms/SimpleCheckboxWithTooltip';

const setListProductsCart = ({
     eventOld,
     eventSelected,
     productSelected,
     listProductCart,
     setListProductCart,
     product,
     setProduct,
     listProducts,
     setListProducts,
     action = 'edit',
     keySelected,
     listActiveSeatByUser,
     option,
     setDisableCart,
}) => {
     const listEventsProduct = productSelected.listEvents;
     const indexEvent = listEventsProduct.findIndex((ev) => ev.value === eventSelected.value);
     const indexEventOld = listEventsProduct.findIndex((ev) => ev.value === eventOld?.value);

     //add or edit
     const eventSelectedIndex = productSelected.listEventSelected.findIndex((item) => item.value === eventSelected.value);
     const eventSelectedOldIndex = productSelected.listEventSelected.findIndex((item) => item.value === eventOld?.value);

     if (action === 'edit') {
          if (eventOld.value !== eventSelected.value) {
               productSelected.listEventSelected[eventSelectedOldIndex] = eventSelected;
               listEventsProduct[indexEventOld].notShow = false;
               if (eventSelected.value !== 'custom') {
                    listEventsProduct[indexEvent].notShow = true;
               }
          } else {
               if (keySelected && eventSelected.value === 'custom') {
                    productSelected.listEventSelected[keySelected] = eventSelected;
               } else {
                    productSelected.listEventSelected[eventSelectedIndex] = eventSelected;
               }
          }
     } else {
          productSelected.listEventSelected.push(eventSelected);

          if (eventSelected.value !== 'custom') {
               listEventsProduct[indexEvent].notShow = true;
          }
     }

     //set list product cart
     const newProduct = { ...productSelected, listEvents: [...listEventsProduct] };
     const indexProduct = listProductCart.findIndex((item) => item.id === newProduct.id);
     const newListProductCart = [...listProductCart];

     newListProductCart[indexProduct] = newProduct;

     setListProductCart(newListProductCart);

     if (productSelected.id === product.id) {
          setProduct(newProduct);
     }

     //set list products
     const indexListProduct = listProducts.findIndex((item) => item.id === newProduct.id);
     const newProducts = [...listProducts];
     newProducts[indexListProduct] = newProduct;

     setListProducts(newProducts);

     const checkEventHasSeat =
          newListProductCart.some((item) =>
               item.listEventSelected.some(
                    (productEventSelected) => item.selected === true && checkProductHasSeat(listActiveSeatByUser, item.id, productEventSelected.value)
               )
          ) && option === TAB_SELECT_PURCHASE.PERSONAL_TRAINING;

     if (checkEventHasSeat && option === TAB_SELECT_PURCHASE.PERSONAL_TRAINING) {
          setDisableCart(true);
     } else {
          setDisableCart(false);
     }
};

const setListProductsCartWithCredit = ({
     productSelected,
     selectedEventCredit,
     listProductCart,
     setListProductCart,
     product,
     setProduct,
     listProducts,
     setListProducts,
     quantityEventCredit,
}) => {
     productSelected.listEventSelected = productSelected.listEventSelected.map((event) => {
          return {
               ...event,
               edit: false,
          };
     });

     const newProduct = { ...productSelected, selectedEventCredit, selectedEventCreditQuantity: quantityEventCredit || 0 };

     const indexProduct = listProductCart.findIndex((item) => item.id === newProduct.id);

     const newListProductCart = [...listProductCart];

     newListProductCart[indexProduct] = newProduct;

     setListProductCart(newListProductCart);

     if (productSelected.id === product.id) {
          setProduct(newProduct);
     }

     //set list products
     const indexListProduct = listProducts.findIndex((item) => item.id === newProduct.id);
     const newProducts = [...listProducts];
     newProducts[indexListProduct] = newProduct;

     setListProducts(newProducts);
};

const EventSelected = ({ typeOfPurchase, productSelected, keySelected, selectedEventCredit, minusQuantityCartLocal }) => {
     const { listProductCart, setListProductCart, product, setProduct, listProducts, setListProducts, setDisableCart, option } =
          useContext(TrainingProductCardContext);

     const isOrganizationPurchase = typeOfPurchase === TAB_SELECT_PURCHASE.TEAM_TRAINING;

     const listActiveSeatByUser = useSelector((state) => state.subscriber.listActiveSeatByUser);

     const eventSelected = { ...productSelected.listEventSelected[keySelected] };
     const label = eventSelected.label;

     const handleEditEvent = () => {
          const eventOld = { ...productSelected.listEventSelected[keySelected] };
          eventSelected.edit = true;
          setListProductsCart({
               eventOld,
               eventSelected,
               productSelected,
               listProductCart,
               setListProductCart,
               product,
               setProduct,
               listProducts,
               setListProducts,
               action: 'edit',
               keySelected,
               setDisableCart,
               selectedEventCredit,
          });
     };

     const removeEventProduct = (productSelected, key) => {
          const productListEventSelected = productSelected?.listEventSelected;
          const eventDelete = [...productListEventSelected];

          const resetError = eventDelete.findIndex((ne) => ne.value === eventDelete[key].value);
          eventDelete[resetError] = {
               ...eventDelete[resetError],
          };
          eventDelete.splice(key, 1);

          const listEventsProduct = productSelected.listEvents;
          const indexEvent = listEventsProduct.findIndex((ev) => ev.value === eventSelected.value);
          listEventsProduct[indexEvent].notShow = false;

          const newProduct = {
               ...productSelected,
               listEventSelected: [...eventDelete],
               listEvents: [...listEventsProduct],
          };

          const indexProduct = listProductCart.findIndex((item) => item.id === newProduct.id);
          const newListProductCart = [...listProductCart];
          newListProductCart[indexProduct] = newProduct;
          setListProductCart(newListProductCart);

          if (productSelected.id === product.id) {
               setProduct(newProduct);
          }

          const indexListProduct = listProducts.findIndex((item) => item.id === newProduct.id);
          const newProducts = [...listProducts];
          newProducts[indexListProduct] = newProduct;
          setListProducts(newProducts);

          const checkEventHasSeat =
               newListProductCart.some((item) =>
                    item.listEventSelected.some(
                         (productEventSelected) =>
                              item.selected === true && checkProductHasSeat(listActiveSeatByUser, item.id, productEventSelected.value)
                    )
               ) && option === TAB_SELECT_PURCHASE.PERSONAL_TRAINING;

          if (checkEventHasSeat) {
               // setDisableCart(true);
          } else {
               setDisableCart(false);
          }

          minusQuantityCartLocal();
     };

     return (
          <div className={`edit-training-team ${selectedEventCredit ? 'disabled' : ''}`}>
               <div className="d-flex justify-content-start">
                    {isOrganizationPurchase && (
                         <div className="head-training">
                              <img src={images.IconColorMan} alt="Date" />
                              <span>x{eventSelected.quantityEvent}</span>
                         </div>
                    )}
                    {label}
               </div>

               {!selectedEventCredit && (
                    <div className="footer-training">
                         <img src={images.IconPencil} alt="" onClick={handleEditEvent} />

                         <img
                              src={images.IconDelete}
                              className="IconDelete"
                              alt=""
                              onClick={() => removeEventProduct(productSelected, keySelected)}
                         />
                    </div>
               )}
          </div>
     );
};

const AddEvent = ({
     event,
     listEventOption,
     typeOfPurchase,
     productSelected,
     action,
     keySelected,
     showZIndex,
     setShowZIndex,
     selectedEventCredit,
}) => {
     const { listProductCart, setListProductCart, product, setProduct, listProducts, setListProducts, option, setDisableCart } =
          useContext(TrainingProductCardContext);

     const wrapperRef = useRef(null);
     const listActiveSeatByUser = useSelector((state) => state.subscriber.listActiveSeatByUser);
     const isOrganizationPurchase = typeOfPurchase === TAB_SELECT_PURCHASE.TEAM_TRAINING;

     const minPurchase = isOrganizationPurchase ? productSelected?.organizationMin : productSelected?.individualMin;

     const [eventSelected, setEventSelected] = useState(event);
     const [quantityEvent, setQuantityEvent] = useState(event?.quantityEvent || minPurchase || 1);
     const [overLay, setOverLay] = useState(false);

     let valueEventSelected = eventSelected ? { ...eventSelected } : null;

     const listEventOptionFilter = listEventOption.filter((event) => event.value !== eventSelected?.value);
     if (eventSelected) {
          const eventFound = listEventOption.find((e) => e.value === eventSelected.value);
          if (eventFound) {
               valueEventSelected = { ...eventFound };
          }

          if (!eventFound && event) {
               valueEventSelected = { ...event };
          }
     }

     const clickOutside = useCallback(() => {
          setShowZIndex(false);
     }, []); // eslint-disable-line react-hooks/exhaustive-deps
     useOutsideHandling(wrapperRef, clickOutside);

     const handleChangeSelect = (e) => {
          setEventSelected(e);
          let newQuantity = quantityEvent;

          if (e.value === 'custom') {
               if (quantityEvent < productSelected.customEventMinSeat) {
                    newQuantity = productSelected.customEventMinSeat;
               }
          } else {
               if (quantityEvent > e.remainingSeats) {
                    newQuantity = e.remainingSeats;
               }
          }

          setQuantityEvent(newQuantity);
          addEventCart(e, newQuantity);
     };

     const addEventCart = (eventSelected, quantity) => {
          if (!eventSelected) {
               return;
          }

          eventSelected.quantityEvent = quantity;
          eventSelected.edit = false;

          setListProductsCart({
               eventOld: event,
               eventSelected,
               productSelected,
               listProductCart,
               setListProductCart,
               product,
               setProduct,
               listProducts,
               setListProducts,
               action,
               listActiveSeatByUser,
               option,
               setDisableCart,
               keySelected,
          });
          setEventSelected(null);
          setQuantityEvent(minPurchase);
     };

     const reduceSeatEvent = () => {
          if (selectedEventCredit) return;

          if (eventSelected?.value === 'custom') {
               if (quantityEvent > productSelected.customEventMinSeat) {
                    const newQuantity = quantityEvent - 1;
                    setQuantityEvent(newQuantity);
               }
          } else {
               if (quantityEvent > productSelected.organizationMin) {
                    const newQuantity = quantityEvent - 1;
                    setQuantityEvent(newQuantity);
               }
          }
     };

     const increaseSeatEvent = () => {
          if (selectedEventCredit) return;

          const maxSeatPurchase = productSelected.organizationMax;
          const comparisonQuantiMax = quantityEvent < maxSeatPurchase;
          const comparisonRemainQuantity = eventSelected?.remainingSeats > quantityEvent;
          const conditionPurchaseSeatEvent = maxSeatPurchase !== -1 && maxSeatPurchase > 0 ? comparisonQuantiMax : comparisonRemainQuantity;

          if (eventSelected?.value === 'custom' || conditionPurchaseSeatEvent || !eventSelected) {
               const newQuantity = quantityEvent + 1;

               setQuantityEvent(newQuantity);
          }
     };

     return (
          <div className={`select-event-wrapper position-relative ${showZIndex ? 'z-index-9999' : 'z-index-2'}`}>
               <div className="group-seat-mobile">
                    {isOrganizationPurchase && (
                         <div className={`change-seat group-seat-mobile ${selectedEventCredit ? 'disabled' : ''}`}>
                              <div className="btn-change-seat d-flex">
                                   <span className="btn btn-change-seat" onClick={reduceSeatEvent}>
                                        -
                                   </span>
                                   <span className="seat">
                                        <img src={images.IconColorMan} width={20} height={20} alt="Icon Color Man" />
                                        <span className="quantity">{quantityEvent}</span>
                                   </span>
                                   {eventSelected?.remainingSeats === quantityEvent || productSelected.organizationMax === quantityEvent ? (
                                        <TooltipWithIcon
                                             className="btn btn-change-seat"
                                             content={`${
                                                  productSelected.organizationMax === quantityEvent
                                                       ? 'Maximum seat purchase is ' + productSelected.organizationMax
                                                       : 'No more seats available.'
                                             }`}
                                             trigger="click"
                                             type="button"
                                             ref={wrapperRef}
                                        >
                                             <span className="btn btn-change-seat" onClick={() => setShowZIndex(true)}>
                                                  +
                                             </span>
                                        </TooltipWithIcon>
                                   ) : (
                                        <span className="btn btn-change-seat" onClick={increaseSeatEvent}>
                                             +
                                        </span>
                                   )}
                              </div>
                         </div>
                    )}
                    {overLay && (
                         <div
                              className="overlay"
                              onClick={() => {
                                   setOverLay(false);
                              }}
                         ></div>
                    )}
                    <div className="form-group">
                         <Select
                              className="select-training"
                              classNamePrefix={`${valueEventSelected?.value !== 'custom' ? 'custom-date-not-select' : ''} ${
                                   listEventOption.some((item) => item.value === 'custom') ? 'has-custom-date-event' : ''
                              } event-select`}
                              placeholder="Select a training date"
                              value={valueEventSelected}
                              options={listEventOptionFilter}
                              isSearchable={false}
                              onChange={handleChangeSelect}
                              onMenuOpen={() => {
                                   setOverLay(true);
                                   setShowZIndex(false);
                              }}
                              onMenuClose={() => {
                                   setOverLay(false);
                                   setShowZIndex(false);
                              }}
                              isDisabled={selectedEventCredit}
                         />
                    </div>
               </div>

               <div className="btn-add-training-date">
                    <>
                         {event?.edit && (
                              <CButton
                                   color="primary"
                                   className={`btn${event?.edit ? ' btn-success' : ' btn-blue-highlight'} `}
                                   disabled={!eventSelected}
                                   onClick={() => addEventCart(valueEventSelected, quantityEvent)}
                              >
                                   <span>{event?.edit && <img src={images.IconCorrect} width="12" height="8" alt="Icon correct" />}</span>
                              </CButton>
                         )}
                    </>
               </div>
          </div>
     );
};

const AddEventForCredit = ({
     typeOfPurchase,
     productSelected,
     showZIndex,
     setShowZIndex,
     selectedEventCredit,
     editEventCredit,
     setEditEventCredit,
     quantityEventCredit,
     setQuantityEventCredit,
}) => {
     const { listProductCart, setListProductCart, product, setProduct, listProducts, setListProducts } = useContext(TrainingProductCardContext);

     const wrapperRef = useRef(null);
     const isOrganizationPurchase = typeOfPurchase === TAB_SELECT_PURCHASE.TEAM_TRAINING;
     const isDisabled = !quantityEventCredit || (selectedEventCredit && !editEventCredit);

     const [overLay, setOverLay] = useState(false);

     const clickOutside = useCallback(() => {
          setShowZIndex(false);
     }, []); // eslint-disable-line react-hooks/exhaustive-deps
     useOutsideHandling(wrapperRef, clickOutside);

     const addEventCart = () => {
          setListProductsCartWithCredit({
               productSelected,
               selectedEventCredit,
               listProductCart,
               setListProductCart,
               product,
               setProduct,
               listProducts,
               setListProducts,
               quantityEventCredit,
          });
          setEditEventCredit(false);
     };

     const reduceSeatEvent = () => {
          if (isDisabled) return;

          if (quantityEventCredit > productSelected.organizationMin) {
               const newQuantity = quantityEventCredit - 1;
               setQuantityEventCredit(newQuantity);
          }
     };

     const increaseSeatEvent = () => {
          if (isDisabled) return;

          const maxSeatPurchase = productSelected.organizationMax;
          const comparisonQuantiMax = quantityEventCredit < maxSeatPurchase;
          const conditionPurchaseSeatEvent = maxSeatPurchase !== -1 && maxSeatPurchase > 0 ? comparisonQuantiMax : true;

          if (conditionPurchaseSeatEvent) {
               const newQuantity = quantityEventCredit + 1;
               setQuantityEventCredit(newQuantity);
          }
     };

     return (
          <div className={`select-event-wrapper position-relative ${showZIndex ? 'z-index-9999' : 'z-index-2'}`}>
               <div className="group-seat-mobile">
                    {isOrganizationPurchase && (
                         <div className={`change-seat group-seat-mobile ${isDisabled ? 'disabled' : ''}`}>
                              <div className="btn-change-seat d-flex">
                                   <span className="btn btn-change-seat" onClick={reduceSeatEvent}>
                                        -
                                   </span>
                                   <span className="seat">
                                        <img src={images.IconColorMan} width={20} height={20} alt="Icon Color Man" />
                                        <span className="quantity">{quantityEventCredit || 1}</span>
                                   </span>

                                   {productSelected.organizationMax === quantityEventCredit ? (
                                        <TooltipWithIcon
                                             className="btn btn-change-seat"
                                             content={`${
                                                  productSelected.organizationMax === quantityEventCredit
                                                       ? 'Maximum seat purchase is ' + productSelected.organizationMax
                                                       : 'No more seats available.'
                                             }`}
                                             trigger="click"
                                             type="button"
                                             ref={wrapperRef}
                                        >
                                             <span className="btn btn-change-seat" onClick={() => setShowZIndex(true)}>
                                                  +
                                             </span>
                                        </TooltipWithIcon>
                                   ) : (
                                        <span className="btn btn-change-seat" onClick={increaseSeatEvent}>
                                             +
                                        </span>
                                   )}
                              </div>
                         </div>
                    )}
                    {overLay && (
                         <div
                              className="overlay"
                              onClick={() => {
                                   setOverLay(false);
                              }}
                         ></div>
                    )}
                    <div className="form-group">
                         <Select
                              className="select-training"
                              classNamePrefix="custom-date-not-select  event-select"
                              placeholder={editEventCredit ? 'Date to be selected in the future' : 'No planned events'}
                              isSearchable={false}
                              onMenuOpen={() => {
                                   setOverLay(true);
                                   setShowZIndex(false);
                              }}
                              onMenuClose={() => {
                                   setOverLay(false);
                                   setShowZIndex(false);
                              }}
                              isDisabled={true}
                         />
                    </div>
               </div>
               <div className="btn-add-training-date">
                    <>
                         {editEventCredit && (
                              <CButton color="primary" className="btn btn-success" onClick={() => addEventCart()}>
                                   <span>
                                        <img src={images.IconCorrect} width="12" height="8" alt="Icon correct" />
                                   </span>
                              </CButton>
                         )}
                    </>
               </div>
          </div>
     );
};

const SelectTrainingDate = ({ productSelected, typeOfPurchase, listProductTypeRequireEvent }) => {
     const dispatch = useDispatch();
     const { listProductCart, setListProductCart, product, setProduct, listProducts, setListProducts, cartLocalStorage } =
          useContext(TrainingProductCardContext);

     const awaitingOrderItems = useSelector((state) => state.subscriber.awaitingOrderItems);
     const [showZIndex, setShowZIndex] = useState(false);

     const contentManagements = useSelector((state) => state.subscriber.contentManagements);
     const listActiveSeatByUser = useSelector((state) => state.subscriber.listActiveSeatByUser);

     const isPersonalPurchase = typeOfPurchase === TAB_SELECT_PURCHASE.PERSONAL_TRAINING;
     const isOrganizationPurchase = typeOfPurchase === TAB_SELECT_PURCHASE.TEAM_TRAINING;
     const minPurchase = isOrganizationPurchase ? productSelected?.organizationMin : productSelected?.individualMin;
     const isPurchaseCreditEnabled = productSelected.allowPurchaseEventCredit;

     const [selectedEventCredit, setSelectedEventCredit] = useState(false);
     const [editEventCredit, setEditEventCredit] = useState(false);
     const [quantityEventCredit, setQuantityEventCredit] = useState(isPurchaseCreditEnabled ? minPurchase : 0);

     const productRequireEvent =
          listProductTypeRequireEvent && productSelected
               ? listProductTypeRequireEvent.some((item) => item.id === productSelected.productTypeId)
               : false;
     const productListEventSelected = productSelected?.listEventSelected;
     const hasCustom = (isPersonalPurchase && productSelected.customEventMinSeat <= 1) || isOrganizationPurchase;
     const isEventCreditSelected = productSelected.selectedEventCredit && productSelected.selectedEventCreditQuantity > 0;

     let listEventFiltered = productSelected.listEvents;
     if (!hasCustom && productSelected.listEvents?.some((item) => item.value === 'custom' || item.value === 'emptyEvent')) {
          listEventFiltered = productSelected.listEvents.filter((item) => item.value !== 'custom' || item.value !== 'emptyEvent');
          if (listEventFiltered.length === 0) {
               listEventFiltered = [{ value: '', label: '' }];
          }
     }

     listEventFiltered = listEventFiltered?.filter((event) => {
          const cartEventLocal = cartLocalStorage?.cartItems?.find((item) => item.eventId === event.value);
          const eventQuantityCart = cartEventLocal?.quantity || 0;
          return (
               eventQuantityCart < event.remainingSeats || event.value === 'custom' || event.value === 'emptyEvent' || event.remainingSeats === null
          );
     });

     const listEventOption = listEventFiltered?.filter((event) => {
          const checkHasSeat = isOrganizationPurchase ? false : checkProductHasSeat(listActiveSeatByUser, productSelected.id, event.value);
          const checkHasAwaitingItems = isOrganizationPurchase ? false : awaitingOrderItems.find((item) => item.eventId === event.value);

          const quantityCartEventItem = cartLocalStorage?.cartItems?.find((item) => item.eventId === event.value)?.quantity;
          let showEventCartItem = false;
          let showEventMinSeatPurchase = false;
          if (typeOfPurchase === TAB_SELECT_PURCHASE.TEAM_TRAINING) {
               showEventCartItem = productSelected?.organizationMax === -1 ? false : quantityCartEventItem >= productSelected?.organizationMax;
               showEventMinSeatPurchase = productSelected?.organizationMin > event.remainingSeats && event.value !== 'custom';
          } else {
               showEventMinSeatPurchase = productSelected?.individualMin > event.remainingSeats && event.value !== 'custom';
          }

          return !event.notShow && !checkHasSeat && !checkHasAwaitingItems && !showEventMinSeatPurchase && !showEventCartItem;
     });

     const fetchDataContentManagements = () => {
          if (!contentManagements.length) {
               dispatch(fetchGuestContentManagements());
          }
     };
     useEffect(fetchDataContentManagements, []); // eslint-disable-line react-hooks/exhaustive-deps

     const titleFormSelect = contentManagements.find((content) => content.key === 'pageSellingGroupDetailTitleFormSelect');

     const minusQuantityCartLocal = (isCheckPurchaseCredit = false) => {
          const cartLocal = cartLocalStorage;
          const cartItemsLocal = cartLocal?.cartItems;
          const cartItems = cartItemsLocal?.length ? cartItemsLocal : [];

          const isHasSelectedCredit = cartItems.some((item) => item.isCredit);

          for (const item of listProductCart) {
               for (let i = 0; i < cartItems.length; i++) {
                    const cartItem = cartItems[i];

                    const selectedEvent = item.listEventSelected.find((event) => event.value === cartItem.eventId);

                    const remainingSeat = selectedEvent?.remainingSeat;

                    const maxQty = Number(remainingSeat || item.organizationMax) || 0;

                    if (maxQty === -1) continue;

                    const currentQty = Number(cartItem.quantity) || 0;
                    const additionalEventQty = Number(!cartItem.isCredit ? selectedEvent?.quantityEvent : 0);
                    const additionalCreditQty = Number(cartItem.isCredit ? item.selectedEventCreditQuantity : 0);
                    const additionalQty = cartItem.isCredit ? additionalCreditQty : additionalEventQty;

                    if (isCheckPurchaseCredit && isHasSelectedCredit && !cartItem.isCredit) {
                         cartItem.quantity -= additionalCreditQty;

                         continue;
                    }
                    if (currentQty > maxQty) {
                         cartItem.quantity -= additionalQty;
                    }
               }
          }

          localStorage.setItem(LOCAL_CART, JSON.stringify(cartLocal));
     };

     const onChangeCredit = (e) => {
          const checkedValue = e.target.checked;

          setSelectedEventCredit(checkedValue);
          isOrganizationPurchase && setEditEventCredit(true);

          setListProductsCartWithCredit({
               productSelected,
               selectedEventCredit: checkedValue,
               listProductCart,
               setListProductCart,
               product,
               setProduct,
               listProducts,
               setListProducts,
               quantityEventCredit: isPersonalPurchase ? minPurchase : 0,
          });

          if (checkedValue) {
               minusQuantityCartLocal(true);
          }

          if (!checkedValue) {
               setQuantityEventCredit(minPurchase);
               setEditEventCredit(false);

               minusQuantityCartLocal();
          }
     };

     const onClickRemoveCredit = () => {
          setSelectedEventCredit(false);
          setQuantityEventCredit(minPurchase);

          setListProductsCartWithCredit({
               productSelected,
               selectedEventCredit: false,
               listProductCart,
               setListProductCart,
               product,
               setProduct,
               listProducts,
               setListProducts,
          });

          minusQuantityCartLocal();
     };

     const isShowSelectCredit = !listEventFiltered?.length && isPurchaseCreditEnabled;

     return (
          <>
               {productRequireEvent && listProductCart.length > 0 && (
                    <div className="select-event-box">
                         {listEventFiltered?.length > 0 || isPurchaseCreditEnabled ? (
                              <>
                                   <div className="select-event-box-title">
                                        <h5>{titleFormSelect?.value}</h5>
                                   </div>

                                   {productListEventSelected?.map((eSelected, key) => {
                                        return (
                                             <div
                                                  key={key}
                                                  className={`d-flex edit-option-selected flex-column ${
                                                       showZIndex ? 'z-index-9999' : `z-index-${productListEventSelected.length - key + 2}`
                                                  }`}
                                             >
                                                  {eSelected.edit ? (
                                                       <AddEvent
                                                            listEventOption={listEventOption}
                                                            typeOfPurchase={typeOfPurchase}
                                                            productSelected={productSelected}
                                                            event={eSelected}
                                                            action="edit"
                                                            keySelected={key}
                                                            setShowZIndex={setShowZIndex}
                                                            showZIndex={showZIndex}
                                                            setQuantityEventCredit={setQuantityEventCredit}
                                                       />
                                                  ) : (
                                                       <EventSelected
                                                            event={eSelected}
                                                            typeOfPurchase={typeOfPurchase}
                                                            productSelected={productSelected}
                                                            keySelected={key}
                                                            selectedEventCredit={selectedEventCredit}
                                                            minusQuantityCartLocal={minusQuantityCartLocal}
                                                       />
                                                  )}

                                                  {listActiveSeatByUser &&
                                                       typeOfPurchase !== TAB_SELECT_PURCHASE.TEAM_TRAINING &&
                                                       checkProductHasSeat(listActiveSeatByUser, productSelected.id, eSelected.value) && (
                                                            <p className="has-active-seat text-danger">
                                                                 You have an active seat, so you cannot purchase it again.
                                                            </p>
                                                       )}
                                             </div>
                                        );
                                   })}

                                   {listEventFiltered?.length > 0 && (
                                        <AddEvent
                                             listEventOption={listEventOption}
                                             typeOfPurchase={typeOfPurchase}
                                             productSelected={productSelected}
                                             action="add"
                                             setShowZIndex={setShowZIndex}
                                             showZIndex={showZIndex}
                                             selectedEventCredit={selectedEventCredit}
                                             setQuantityEventCredit={setQuantityEventCredit}
                                        />
                                   )}

                                   {isShowSelectCredit && (
                                        <AddEventForCredit
                                             typeOfPurchase={typeOfPurchase}
                                             productSelected={productSelected}
                                             setShowZIndex={setShowZIndex}
                                             showZIndex={showZIndex}
                                        />
                                   )}
                              </>
                         ) : (
                              <strong className="mt-2 mb-2 d-block">There are currently no events. Please come back later</strong>
                         )}

                         {/* Select Credit Section */}
                         {isPurchaseCreditEnabled && (
                              <div className="select-credit-section">
                                   <SimpleCheckboxWithTooltip
                                        id={`selectPurchaseCredit${isPersonalPurchase ? 'Personal' : 'Organization'} `}
                                        label={productSelected.purchaseEventCreditHeadline}
                                        checked={selectedEventCredit}
                                        tooltip={productSelected.purchaseEventCreditTooltip}
                                        onChange={onChangeCredit}
                                   />

                                   {selectedEventCredit && editEventCredit && (
                                        <AddEventForCredit
                                             typeOfPurchase={typeOfPurchase}
                                             productSelected={productSelected}
                                             action="add"
                                             setShowZIndex={setShowZIndex}
                                             showZIndex={showZIndex}
                                             selectedEventCredit={selectedEventCredit}
                                             editEventCredit={editEventCredit}
                                             setEditEventCredit={setEditEventCredit}
                                             quantityEventCredit={quantityEventCredit}
                                             setQuantityEventCredit={setQuantityEventCredit}
                                        />
                                   )}

                                   {selectedEventCredit && !editEventCredit && (
                                        <div className="edit-training-team">
                                             <div className="d-flex justify-content-start selected-box-label">
                                                  {isOrganizationPurchase && (
                                                       <div className="head-training">
                                                            <img src={images.IconColorMan} alt="Date" />
                                                            <span>x{quantityEventCredit}</span>
                                                       </div>
                                                  )}
                                                  <span>Date to be selected in the future</span>
                                             </div>

                                             <div className="footer-training">
                                                  {isOrganizationPurchase && (
                                                       <img
                                                            src={images.IconPencil}
                                                            alt=""
                                                            onClick={() => {
                                                                 setEditEventCredit(true);
                                                            }}
                                                       />
                                                  )}
                                                  <img src={images.IconDelete} className="IconDelete" alt="" onClick={onClickRemoveCredit} />
                                             </div>
                                        </div>
                                   )}
                              </div>
                         )}

                         {(productListEventSelected?.length > 0 || isEventCreditSelected) && (
                              <p className="text-center">
                                   <small>Scroll down and add to cart.</small>
                              </p>
                         )}
                    </div>
               )}
          </>
     );
};

export default SelectTrainingDate;
